import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Button1 from "../../../components/form/Button1";
import { formatMoney } from "../../../features/utils/formatMoney";
import { WORLD_CUP_TEAMS } from "./payload";

export default function WorldCupActiveGameCard({ game }) {
  const navigate = useNavigate();
  const gameId = game?._id || game?.id;  const teamCount = game?.teams?.length || WORLD_CUP_TEAMS.length;
  const tournamentYear = game?.tournamentYear || 2026;

  return (
    <div className="overflow-hidden rounded-2xl border border-[#E7EDF5] bg-white shadow-sm">
      <div className="relative bg-gradient-to-br from-[#0B3D91] via-[#1565C0] to-[#1E88E5] px-6 py-8 text-white">
        <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-12 -left-6 h-28 w-28 rounded-full bg-white/10" />

        <div className="relative flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-col gap-4">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em]">
              <Icon icon="mdi:soccer" className="text-sm" />
              Active Tournament
            </span>

            <div className="flex flex-col gap-2">
              <span className="text-3xl font-bold tracking-tight sm:text-4xl">
                {game?.name || "FIFA World Cup 2026"}
              </span>
              <span className="max-w-xl text-sm text-white/80 sm:text-base">
                The World Cup game is live with {teamCount} nations competing for
                the prize pool below.
              </span>
            </div>
          </div>

          <div className="rounded-2xl border border-white/20 bg-white/10 px-5 py-4 backdrop-blur-sm">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-white/75">
              Prize Pool
            </span>
            <span className="mt-2 block text-3xl font-extrabold sm:text-4xl">
              {formatMoney(game?.prizePoolAmount)}
            </span>
          </div>
        </div>
      </div>

      <div className="grid gap-4 p-6 sm:grid-cols-3">
        <div className="rounded-xl border border-[#E7EDF5] bg-[#F8FAFD] px-4 py-4">
          <span className="text-xs font-medium uppercase tracking-wide text-[#6D7C94]">
            Tournament Year
          </span>
          <span className="mt-2 block text-lg font-semibold text-primary">
            {tournamentYear}
          </span>
        </div>

        <div className="rounded-xl border border-[#E7EDF5] bg-[#F8FAFD] px-4 py-4">
          <span className="text-xs font-medium uppercase tracking-wide text-[#6D7C94]">
            Teams
          </span>
          <span className="mt-2 block text-lg font-semibold text-primary">
            {teamCount} nations
          </span>
        </div>

        <div className="rounded-xl border border-[#E7EDF5] bg-[#F8FAFD] px-4 py-4">
          <span className="text-xs font-medium uppercase tracking-wide text-[#6D7C94]">
            Status
          </span>
          <span className="mt-2 flex items-center gap-2 text-lg font-semibold text-primary">
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
            {game?.status || "Active"}
          </span>
        </div>
      </div>

      <div className="border-t border-[#E7EDF5] px-6 py-5">
        <Button1
          type="button"
          className="!bg-[#C2410C] hover:!bg-[#9A3412]"
          onClick={() => navigate(`/settings/world-cup/settle/${gameId}`)}
        >          Settle Game
        </Button1>
      </div>
    </div>
  );
}
